// extracted by mini-css-extract-plugin
export default {"desktop":"LjmcQ0H1oQqREOW3tEpQ","svgBorder":"BFfeaLAXLFsdN22if_tk","mobile":"hqubtXBvlBTm2rLlsHqQ","pulse":"cK4rc6LRujdeQS9_L516"};